import URLJS from "urijs";
import queryString from "qs";

export const PORTAL_BASE_URL = process.env.REACT_APP_PORTAL_BASE_URL;
export const REG_EXP_STR_FOR_UUID =
  "[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}";

export const parseQueryOf = (props: { location: any }) => {
  return queryString.parse(props.location.search.replace("?", ""));
};

export const parseQueryOfLocation = (location: any) => {
  return queryString.parse(location.search.replace("?", ""));
};

export const toQueryString = (obj: { [key in string]?: string }) => {
  const filtered = Object.entries(obj).filter((e) => !!e[1]);
  if (filtered.length === 0) {
    return "";
  }
  return "?" + filtered.map((e) => `${e[0]}=${e[1]}`).join("&");
};

export const rebuildQuery = (queries: {
  [key: string]: string | string[] | undefined;
}) => {
  let url = new URLJS(window.location.pathname + window.location.search);
  Object.keys(queries).forEach((k) => {
    const v = queries[k];
    if (v) {
      if (typeof v === "string") {
        url = url.setQuery(k, v);
      } else {
        url = url.setQuery(k, JSON.stringify(v));
      }
    } else {
      url = url.removeQuery(k);
    }
  });
  return url.toString();
};

export const buildSentryDSN = () => {
  return new URLJS({
    protocol: window.location.protocol.slice(0, -1),
    port: window.location.port,
    hostname: window.location.hostname,
    username: "f53a2dfb25224a9aab86c68dad86367b",
    path: "/1512196",
  }).toString();
};

export const isValidHTTPUrl = (str: string) => {
  let parsed;
  try {
    parsed = new window.URL(str);
  } catch (_) {
    return false;
  }
  return parsed.protocol === "http:" || parsed.protocol === "https:";
};

export const isValidHTTPUrlWithURLJS = (str: string) => {
  const parsed = new URLJS(str);
  return parsed.protocol() === "http" || parsed.protocol() === "https";
};

export const isValidRedirect = (to: string): boolean => {
  return !!to.match(/^\/(?!\/)/);
};
